@if (maxVal() > 0) {
  <div
    class="fuelbar-progress k-overflow-hidden k-pos-relative k-w-full k-mt-3"
    [class.exceeded]="currentVal() > maxVal()"
    [class.thin]="thin()"
  >
    <div
      class="fuelbar-progress-current k-pos-absolute k-left-0"
      [style.width.%]="(currentVal() / maxVal()) * 100"
    ></div>
  </div>
}
